import { render, staticRenderFns } from "./iconFormPlus.vue?vue&type=template&id=1007839c&scoped=true&"
import script from "./iconFormPlus.vue?vue&type=script&lang=js&"
export * from "./iconFormPlus.vue?vue&type=script&lang=js&"
import style0 from "./iconFormPlus.vue?vue&type=style&index=0&id=1007839c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1007839c",
  null
  
)

export default component.exports